import React from 'react';
import { useAppDispatch } from '../app/redux/useAppSelector';
import { MenuItem } from '../components/Menu';
import { ACTION_REFERRAL_MODAL, CATEGORY_GROWTH } from '../constants/analytics';
import giftIcon from '../icons/non-prefilled/16x16/gift.svg';
import { UIActions } from '../ui/uiSlice';
import { track } from '../utils/analytics';
import ReferralModal from './ReferralModal';

interface ReferralMenuItemProps {
  showIcon?: boolean;
}

const ReferralMenuItem = ({ showIcon = true }: ReferralMenuItemProps) => {
  const dispatch = useAppDispatch();
  const handleOpenReferralModal = () => {
    track(ACTION_REFERRAL_MODAL, { category: CATEGORY_GROWTH });
    dispatch(UIActions.openModal(ReferralModal));
  };

  return (
    // @ts-ignore-error
    <MenuItem
      icon={showIcon ? giftIcon : undefined}
      onClick={handleOpenReferralModal}
    >
      Refer & earn
    </MenuItem>
  );
};

export default ReferralMenuItem;
